const HisCalendarCheck = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  return (
    <svg
      style={sx}
      stroke={strokeColor}
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.5835 18.6753V8.02881C28.5835 7.3229 28.3031 6.64591 27.8039 6.14676C27.3048 5.64761 26.6278 5.36719 25.9219 5.36719H7.29053C6.58462 5.36719 5.90763 5.64761 5.40848 6.14676C4.90933 6.64591 4.62891 7.3229 4.62891 8.02881V26.6602C4.62891 27.3661 4.90933 28.0431 5.40848 28.5422C5.90763 29.0414 6.58462 29.3218 7.29053 29.3218H17.937"
        stroke={strokeColor}
        strokeWidth="2.66162"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9297 2.70312V8.02637"
        stroke={strokeColor}
        strokeWidth="2.66162"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2832 2.70312V8.02637"
        stroke={strokeColor}
        strokeWidth="2.66162"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.62891 13.3516H28.5835"
        stroke={strokeColor}
        strokeWidth="2.66162"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9297 26.6577L24.5913 29.3193L29.9146 23.9961"
        stroke={strokeColor}
        strokeWidth="2.66162"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisCalendarCheck;
